import type { ReactNode } from 'react';

import { FONT_AWESOME_GLYPHS, IconProvider, ThemeProvider } from '@ngsos/portal-ui';
import type { IconRendererProps, ThemeColors } from '@ngsos/portal-ui';

const BOOTSTRAP_COLORS = {
  background: 'var(--bs-body-bg)',
  surface: 'var(--bs-body-bg)',
  surfaceAlt: 'var(--bs-tertiary-bg)',
  border: 'var(--bs-border-color)',
  text: 'var(--bs-body-color)',
  textMuted: 'var(--bs-secondary-color)',
  textInverse: 'var(--bs-white)',
  textInverseMuted: 'var(--bs-gray-400)',
  onPrimary: 'var(--bs-white)',
  dark: 'var(--bs-dark)',
  danger: 'var(--bs-danger)',
  onDanger: 'var(--bs-white)',
  dangerSubtle: 'var(--bs-danger-bg-subtle)',
  onDangerSubtle: 'var(--bs-danger-text-emphasis)',
  success: 'var(--bs-success)',
  onSuccess: 'var(--bs-white)',
  successSubtle: 'var(--bs-success-bg-subtle)',
  onSuccessSubtle: 'var(--bs-success-text-emphasis)',
  warning: 'var(--bs-warning)',
  onWarning: 'var(--bs-dark)',
  warningSubtle: 'var(--bs-warning-bg-subtle)',
  onWarningSubtle: 'var(--bs-warning-text-emphasis)',
  info: 'var(--bs-info)',
  onInfo: 'var(--bs-dark)',
  infoSubtle: 'var(--bs-info-bg-subtle)',
  onInfoSubtle: 'var(--bs-info-text-emphasis)',
  skeleton: 'var(--bs-secondary-bg)',
  chatBubbleIncoming: 'var(--bs-tertiary-bg)',
  onChatBubbleIncoming: 'var(--bs-body-color)',
} satisfies Partial<ThemeColors>;

function FontAwesomeIcon({ name, size, color }: IconRendererProps) {
  return (
    <i className={`fa-light fa-${FONT_AWESOME_GLYPHS[name]}`} aria-hidden="true" style={{ fontSize: size, color }} />
  );
}

export function WebUiProvider({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider primaryColor="var(--bs-primary)" colors={BOOTSTRAP_COLORS} fontFamilyBase="Open Sans">
      <IconProvider renderer={FontAwesomeIcon}>{children}</IconProvider>
    </ThemeProvider>
  );
}
